/**
 * Single offer configuration for the landing page.
 * - price + currency: shown as soon as both are set (confirmed: 19 EUR).
 * - checkoutUrl: while null, the purchase button stays disabled (« BIENTÔT DISPONIBLE »).
 * - bonusValuesConfirmed: the indicative bonus values stay hidden until confirmed separately.
 */
export interface OfferConfig {
  /** Confirmed sale price of the complete collection. */
  price: number | null
  /** Confirmed ISO 4217 currency code. */
  currency: string | null
  /** Confirmed checkout destination. */
  checkoutUrl: string | null
  /** true only once a one-time payment has been confirmed. */
  oneTimePayment: boolean | null
  /** true only once the indicative bonus values are confirmed for public display. */
  bonusValuesConfirmed: boolean
}

export const offer: OfferConfig = {
  price: 19,
  currency: 'EUR',
  checkoutUrl: 'https://musiqueprete.impultienda.ar/checkout',
  oneTimePayment: null,
  bonusValuesConfirmed: false,
}
